import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthContext";
import "./LoginPage.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Role from "../../Enum/Roles";
import { loginTeacher } from "../../../ApiController/teacherApi";

function LoginPage() {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const { login } = useAuth();

	const handleLogin = async (e) => {
		e.preventDefault();

		if (!username || !/^[a-zA-Z]+$/.test(username)) {
			alert("Ogiltiga tecken för användarnamn.");
			return;
		}

		setIsLoading(true);

		try {
			const data = await loginTeacher(username, password);

			if (data.success) {
				if (password === 'Abc1234@') {
					alert("Du har loggat in med det förinställda lösenordet. För din säkerhet rekommenderars det att du omedelbart ändrar ditt lösenord.");
				}				
				login(username, data.role);
				sessionStorage.setItem("userId", username);
				navigate(data.role === Role.ADMIN ? "/adminpage" : "/userpage");
			} else {
				alert(data.message || "Okänt fel inträffade");
			}
		} catch (error) {
			console.error("Operation fel:", error);
			if (error.response) {
				if (error.response.status === 401) {
					const errorMessage =
						error.response.data.message ||
						"Felaktigt användarnamn eller lösenord.";
					alert(errorMessage);
				} else {
					alert(
						"Ett fel inträffade under operationen. Det kan vara ett problem med databasen eller nätverket."
					);
				}
			}
		}

		setIsLoading(false);
	};

	if (isLoading) {
		return <div>Laddar...</div>;
	}

	// Formuläret för användarinloggning.
	return (
		<div className="login-container">
			<form onSubmit={handleLogin}>
				<h1>Inloggning</h1>
				<div className="form-group">
					<label htmlFor="username">Användarnamn:</label>
					<input
						type="text"
						id="username"
						value={username}
						onChange={(e) => setUsername(e.target.value.trim())}
					/>
				</div>
				<div className="form-group">
					<label htmlFor="password">Lösenord:</label>
					<input
						type="password"
						id="password"
						value={password}
						onChange={(e) => setPassword(e.target.value.trim())}
					/>
				</div>
				<button type="submit" className="btn btn-primary">
					Logga in
				</button>
			</form>
		</div>
	);
}

export default LoginPage;
